export const contractColumns = [
  'Product',
  'Formula',
  'Contract Weight, mt',
  'Shipments',
  'Seller',
  'Buyer',
  'Completed Shipments',
];
